<div
  class="sbi-toast-item sbi-toast-item--{{ toast().type }}"
  [class.is-active]="isActive()"
  [attr.role]="isUrgent ? 'alert' : 'status'"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="sbi-toast-item__content">
    <div class="sbi-toast-item__icon-wrapper">
      <i [class]="iconClass"></i>
    </div>
    <p class="sbi-toast-item__message">{{ toast().message }}</p>
    <button
      type="button"
      class="sbi-toast-item__close"
      aria-label="Cerrar notificación"
      (click)="onClose()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="sbi-toast-item__progress-track">
    <div
      class="sbi-toast-item__progress-fill"
      [class.sbi-toast-item__progress-fill--paused]="isPaused()"
      [style.--duration]="durationStyle"
    ></div>
  </div>
</div>
